/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActivityResponse,
  HTTPValidationError,
  ListClientActivityParams
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Everything that has happened with this client, newest first.
 *
 * One page of the union of every dated source about the client: the
 * application's own log, notes and calls, tasks, meetings, portal messages,
 * mail, documents, signatures, transfers, portal access, accounts. See
 * ``activity_feed`` for how the sources are read and merged, and why a page
 * is exact even though it is merged in Python.
 * @summary List Client Activity
 */
export const listClientActivity = (
    clientId: string,
    params?: ListClientActivityParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<ActivityResponse>(
      {url: `/clients/${clientId}/activity`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListClientActivityQueryKey = (clientId: string,
    params?: ListClientActivityParams,) => {
    return [
    `/clients/${clientId}/activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getListClientActivityQueryOptions = <TData = Awaited<ReturnType<typeof listClientActivity>>, TError = HTTPValidationError>(clientId: string,
    params?: ListClientActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listClientActivity>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListClientActivityQueryKey(clientId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listClientActivity>>> = ({ signal }) => listClientActivity(clientId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: clientId !== null && clientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listClientActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type ListClientActivityQueryResult = NonNullable<Awaited<ReturnType<typeof listClientActivity>>>
export type ListClientActivityQueryError = HTTPValidationError


/**
 * @summary List Client Activity
 */

export function useListClientActivity<TData = Awaited<ReturnType<typeof listClientActivity>>, TError = HTTPValidationError>(
 clientId: string,
    params?: ListClientActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listClientActivity>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListClientActivityQueryOptions(clientId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






